import React from 'react';
import {Layout} from './Layout';

type Props = {
  children?: React.ReactNode;
};
export const Panel: React.FC<Props> = ({children}) => {
  return (
    <Layout
      flex={1}
      position="relative"
      sx={theme => ({
        p: 2,
        backgroundColor: theme.palette.primary.light,
        borderRadius: 1,
        height: '100%',
        width: '100%',
      })}>
      {children}
    </Layout>
  );
};
